<script lang="ts" setup>
import { storeToRefs } from "pinia";
import { useLevels } from "~/stores/useLevels";

const props = defineProps({
  isMultiple: {
    type: Boolean,
    required: false,
    default: false,
  },
  showAll: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const emit = defineEmits(["onchange"]);

const levelsStore = useLevels();

const { allUserLevels, allLevels, isLoadingLevels } = storeToRefs(levelsStore);

onMounted(() => {
  levelsStore.initializeLevels();
});

const levels = computed(() => {
  const l = props.showAll ? allLevels.value : allUserLevels.value;
  l.sort((a, b) => a.displayOrder - b.displayOrder);

  return l;
});

const placeholder = computed(() => {
  return isLoadingLevels.value ? "Loading levels..." : "Select a level";
});
</script>

<template>
  <BaseSelectInput
    :can-clear="true"
    :options="levels"
    value-prop="id"
    label="name"
    :placeholder="placeholder"
    class="w-full"
    :allow-multiple="isMultiple"
  />
  <!-- <BaseSelect
    :mode="mode"
    :searchable="true"
    :can-clear="true"
    :close-on-select="isMultiple != true"
    :hide-selected="isMultiple != true"
    :options="levels"
    value-prop="id"
    label="name"
    :placeholder="placeholder"
    @change="onChange"
    class=" bg-op"
  /> -->
</template>

<style scoped></style>
